// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Sermorelin Refill 09.17.26" (7c7e5f52-2cce-49a3-b613-df034b3fe1a2). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiSermorelinRefillQuestions = [
  {
    field: 'mdiSermorelinRefill_changesMedicalHistorySinceLast',
    label:
      'Do you have any changes to your medical history since you last received this prescription?',
    type: 'select',
    educationalSlide:
      'If yes, please provide as much information as possible so your doctor can determine if your refill is safe and appropriate.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '7ef79dd8-3d5e-42ba-8090-827acc9b8679' }
  },
  {
    field: 'mdiSermorelinRefill_newAllergiesSinceLastPrescription',
    label:
      'Do you have any new allergies since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '3c3033db-1d19-4085-86e5-721cd617f105' }
  },
  {
    field: 'mdiSermorelinRefill_diagnosedCancerSinceLastPrescription',
    label:
      'Have you been diagnosed with cancer since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '15573566-f817-480c-b0b2-4849622006cf' }
  },
  {
    field: 'mdiSermorelinRefill_diagnosedLiverKidneyDiseaseSince',
    label:
      'Have you been diagnosed with any liver or kidney disease since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '8cbabe4d-328a-4fbe-93cb-47ddc12ce511' }
  },
  {
    field: 'mdiSermorelinRefill_erVisitsHospitalizationsSinceLast',
    label:
      'Have you had any ER visits or hospitalizations since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '1f4cbeb7-c153-439e-94f4-ddfb970dc73e' }
  },
  {
    field: 'mdiSermorelinRefill_havingSideEffectsCurrentTreatment',
    label: 'Are you having any side effects from your current treatment?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '99ae6bf9-7862-4b3f-b37b-33466b1fd23b' }
  },
  {
    field: 'mdiSermorelinRefill_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent form.   (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiSermorelinRefill_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: 'ae8723ee-67f0-4774-a57e-e4090dedd746' }
  },
  {
    field: 'mdiSermorelinRefill_messageDoctorLetThemKnow',
    label:
      'This is your message to your doctor, please let them know how you are doing on your current treatment and why you want to continue on your treatment.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiSermorelinRefill_messageDoctorLetThemKnow',
      rows: 4
    },
    extras: { mdiQuestionId: 'b9511df0-f0c1-49d8-8d07-22a40bc5d43a' }
  },
  {
    field: 'mdiSermorelinRefill_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiSermorelinRefillAnswerField = Partial<
  QuestionAnswerMap<typeof mdiSermorelinRefillQuestions>
>;

export default mdiSermorelinRefillQuestions;
